import { useEffect, useState } from "react";
const axios = require("axios");

//  documentation https://blog.openreplay.com/integrating-axios-with-react-hooks/
//  https://www.gatsbyjs.com/docs/adding-search-with-js-search/#js-search-with-a-small-to-medium-dataset

export const useAxios = (
  {
    url,
    method,
    payload = {},
    headers = {
      apikey: process.env.GATSBY_COUNTRY_ID_APIKEY,
    },
  },
  countryId,
) => {
  const [data, setData] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [loaded, setLoaded] = useState(false);
  //const controllerRef = useRef(new AbortController())

  const cancel = () => {
    // controllerRef.current.abort()
  };

  useEffect(() => {
    const asyncFetch = async () => {
      try {
        const response = await axios.request({
          data: payload,
          headers,
          // signal: controllerRef.current.signal,
          method,
          url,
        });

        setData(response.data);
      } catch ({ message }) {
        setErrorMessage(message);
      } finally {
        setLoaded(true);
      }
    };
    asyncFetch();
  }, [url, countryId]);

  return { cancel, data, errorMessage, loaded };
};
